<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 *ngIf="!diagnostic" class="text-end text-secondary pb-2">Création d'un diagnostic d'entrée IER</h3>
    <h3 *ngIf="diagnostic" class="text-end text-secondary pb-2">Diagnostic d'entrée IER du {{ diagnostic.beginDateOrientation | date }}</h3>
  </div>

  <form *ngIf="diagnosticDetailsForm" [formGroup]="diagnosticDetailsForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <!-- Date d'entrée / Statut / Date MAJ statut -->
      <div class="row">
        <div class="mb-3 col-12 col-lg-4">
          <label class="required">Début d'orientation</label>
          <app-datepicker
            id="fieldBeginDateOrientation"
            formControlName="beginDateOrientation"
            [invalid]="submitted && diagnosticDetailsForm.controls.beginDateOrientation.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && diagnosticDetailsForm.controls?.beginDateOrientation?.errors?.required" class="form-text text-danger">
            La date de début est requise.
          </small>
          <small *ngIf="submitted && diagnosticDetailsForm.controls?.beginDateOrientation?.errors?.dateFormat" class="form-text text-danger">
            La date de début est invalide.
          </small>
        </div>
        <div class="mb-3 col-12 col-lg-4">
          <label class="text-secondary required">Statut</label>
          <select
            class="form-select"
            formControlName="diagnosticStatus"
            (change)="onStatusChange()"
            [class.is-invalid]="submitted && diagnosticDetailsForm.controls.diagnosticStatus.invalid"
          >
            <option *ngIf="!diagnosticDetailsForm.value.diagnosticStatus" [ngValue]="null" selected></option>
            <option *ngFor="let diagnosticStatus of diagnosticStatusMap | keyvalue: StringUtils.stringAscOrder" [ngValue]="diagnosticStatus.key">
              {{ diagnosticStatus.value }}
            </option>
          </select>
          <small *ngIf="submitted && diagnosticDetailsForm.controls?.diagnosticStatus?.errors?.required" class="form-text text-danger">
            Le statut est requis.
          </small>
        </div>
        <div class="mb-3 col-12 col-lg-4">
          <label class="text-secondary">Date MAJ statut diagnostic</label>
          <app-datepicker id="fieldstatusDate" formControlName="statusDate"></app-datepicker>
        </div>
      </div>

      <!-- Diagnostic -->
      <div class="card border-1 card-border-radius-0" formGroupName="diagnosticForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Diagnostic</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <!-- Etat civil - coordonnées -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong> État civil - Coordonnées </strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3">
                          <div class="form-check form-check-inline">
                            <input id="madam" type="radio" class="form-check-input" formControlName="title" name="title" value="Madam" />
                            <label for="madam" class="form-check-label">Madame</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3">
                          <div class="form-check form-check-inline">
                            <input id="mister" type="radio" class="form-check-input" formControlName="title" name="title" value="Mister" />
                            <label for="mister" class="form-check-label">Monsieur</label>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Nom</label>
                            <input type="text" class="form-control" formControlName="usualName" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Prénom</label>
                            <input type="text" class="form-control" formControlName="firstName" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4 mb-3 text-secondary">
                          <label>Date de naissance</label>
                          <app-datepicker id="fieldBirthDate" formControlName="birthDate"> </app-datepicker>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-lg-6">
                          <div class="mb-3 text-secondary">
                            <label>Statut d'habitation</label>
                            <select class="form-select" formControlName="residentialStatus">
                              <option value=""></option>
                              <option
                                *ngIf="diagnosticForm.controls.residentialStatus.value"
                                [ngValue]="diagnosticForm.controls.residentialStatus.value"
                              >
                                {{ residentialStatusEnum[diagnosticForm.controls.residentialStatus.value] }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-12 col-lg-6">
                          <div class="mb-3 text-secondary">
                            <label>Complément de statut</label>
                            <input type="text" class="form-control" formControlName="residentialStatusComplement" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-6">
                          <div class="mb-3 text-secondary">
                            <label>Adresse</label>
                            <input type="text" class="form-control" formControlName="address" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-6">
                          <div class="mb-3 text-secondary">
                            <label>Complément d'adresse</label>
                            <input type="text" class="form-control" formControlName="additionalAddress" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-3">
                          <div class="mb-3 text-secondary">
                            <label>Ville</label>
                            <input type="text" class="form-control" formControlName="city" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-3">
                          <div class="mb-3 text-secondary">
                            <label>Code postal</label>
                            <input type="text" class="form-control" formControlName="postalCode" />
                          </div>
                        </div>
                      </div>

                      <!-- Situation familiale -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong> Situation familiale </strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-3 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="single"
                              type="radio"
                              class="form-check-input"
                              formControlName="maritalStatus"
                              name="maritalStatus"
                              value="Single"
                              [class.is-invalid]="submitted && diagnosticForm.controls.maritalStatus.invalid"
                            />
                            <label for="single" class="form-check-label">célibataire</label>
                          </div>
                        </div>
                        <div class="col-3 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="pacs"
                              type="radio"
                              class="form-check-input"
                              formControlName="maritalStatus"
                              name="maritalStatus"
                              value="PACS"
                              [class.is-invalid]="submitted && diagnosticForm.controls.maritalStatus.invalid"
                            />
                            <label for="pacs" class="form-check-label">pacsé·e</label>
                          </div>
                        </div>
                        <div class="col-3 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="married"
                              type="radio"
                              class="form-check-input"
                              formControlName="maritalStatus"
                              name="maritalStatus"
                              value="Married"
                              [class.is-invalid]="submitted && diagnosticForm.controls.maritalStatus.invalid"
                            />
                            <label for="married" class="form-check-label">marié·e</label>
                          </div>
                        </div>
                        <div class="col-3 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="separated"
                              type="radio"
                              class="form-check-input"
                              formControlName="maritalStatus"
                              name="maritalStatus"
                              value="Separated"
                              [class.is-invalid]="submitted && diagnosticForm.controls.maritalStatus.invalid"
                            />
                            <label for="separated" class="form-check-label">séparé·e</label>
                          </div>
                        </div>
                        <div class="col-3 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="divorced"
                              type="radio"
                              class="form-check-input"
                              formControlName="maritalStatus"
                              name="maritalStatus"
                              value="Divorced"
                              [class.is-invalid]="submitted && diagnosticForm.controls.maritalStatus.invalid"
                            />
                            <label for="divorced" class="form-check-label">divorcé·e</label>
                          </div>
                        </div>
                        <div class="col-3 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="widowed"
                              type="radio"
                              class="form-check-input"
                              formControlName="maritalStatus"
                              name="maritalStatus"
                              value="Widowed"
                              [class.is-invalid]="submitted && diagnosticForm.controls.maritalStatus.invalid"
                            />
                            <label for="widowed" class="form-check-label">veuf·ve</label>
                          </div>
                        </div>
                        <small *ngIf="submitted && diagnosticForm.controls?.maritalStatus?.errors?.required" class="form-text text-danger">
                          la Situation familiale est requise.
                        </small>
                      </div>
                      <div class="row mt-2">
                        <div class="col-6 col-lg-3">
                          <div class="mb-3 text-secondary">
                            <label>Âge conjoint</label>
                            <input type="text" class="form-control" formControlName="spouseAge" maxlength="3" />
                            <small *ngIf="submitted && diagnosticForm.controls?.spouseAge?.errors?.pattern" class="form-text text-danger"
                              >Seuls les nombres sont autorisés.</small
                            >
                          </div>
                        </div>
                        <div class="col-12 col-lg-9">
                          <div class="mb-3 text-secondary">
                            <label>Situation scolaire ou professionnelle conjoint</label>
                            <input type="text" class="form-control" formControlName="spouseOccupation" />
                          </div>
                        </div>
                      </div>

                      <!-- Enfant à charge -->
                      <div class="row">
                        <app-dynamic-form
                          #children
                          class="col-12"
                          title="Enfants à charge"
                          [data]="diagnostic.children"
                          [showSeparator]="false"
                          [fields]="childrenFields"
                          [validators]="validators"
                          [asyncValidators]="asyncValidators"
                          [validatorsMessageTemplate]="validatorsTemplate"
                          noGroupText="Il n'y a aucun enfant à charge de renseigné. Cliquez sur le bouton + pour en ajouter."
                        >
                          <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                            <div class="text-secondary col-3 mb-2" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Âge enfant</label>
                              <input
                                type="text"
                                class="form-control me-3"
                                formControlName="childAge"
                                maxlength="3"
                                [class.is-invalid]="submitted && group.controls?.childAge?.invalid"
                              />
                              <small *ngIf="submitted && group.controls?.childAge?.errors?.required" class="form-text text-danger"
                                >L'âge est requis.</small
                              >
                              <small *ngIf="submitted && group.controls?.childAge?.errors?.pattern" class="form-text text-danger"
                                >Seuls les nombres sont autorisés.</small
                              >
                            </div>
                            <div class="text-secondary col-12 col-lg-9 mb-2" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0"
                                >Situation scolaire ou professionnelle enfant</label
                              >
                              <div class="input-group">
                                <input
                                  type="text"
                                  class="form-control me-3 rounded"
                                  formControlName="childOccupation"
                                  [class.is-invalid]="submitted && group.controls?.childOccupation?.invalid"
                                />
                                <button
                                  type="button"
                                  ngbTooltip="Supprimer"
                                  placement="left"
                                  class="btn btn-outline-primary rounded"
                                  (click)="groupRemoved(groupIndex)"
                                >
                                  <fa-icon icon="trash-alt"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                            <div class="row">
                              <div class="col-12 d-flex justify-content-between">
                                <p>
                                  <strong>{{ title }}</strong>
                                </p>
                                <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" (click)="groupAdded()">
                                  <fa-icon icon="plus"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                        </app-dynamic-form>
                      </div>

                      <!-- Statut au regard de l'emploi -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong> Statut au regard de l'emploi </strong>
                          </p>
                          <p>
                            Pour les diagnostics IER, compléter la date de dernière inscription France Travail dans l'onglet État civil du dossier.
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3">
                          <div class="form-check">
                            <input id="jobCenterRegistration" type="checkbox" class="form-check-input" formControlName="jobCenterRegistration" />
                            <label class="form-check-label" for="jobCenterRegistration">Inscription France Travail</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3">
                          <div class="form-check">
                            <input id="RSA" type="checkbox" class="form-check-input" formControlName="RSA" name="RSA" />
                            <label for="RSA" class="form-check-label">RSA</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3">
                          <div class="form-check">
                            <input id="RQTH" type="checkbox" class="form-check-input" formControlName="RQTH" name="RQTH" />
                            <label for="RSA" class="form-check-label">RQTH</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3">
                          <div class="form-check">
                            <input id="mission" type="checkbox" class="form-check-input" formControlName="mission" name="mission" />
                            <label for="mission" class="form-check-label">Mission locale</label>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12 col-lg-6">
                          <div class="mb-3 text-secondary">
                            <label>Nature du dernier emploi</label>
                            <input type="text" class="form-control" formControlName="natureLastJob" />
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12 col-lg-6 mb-3 text-secondary">
                          <label>Date de début dernier emploi</label>
                          <app-datepicker id="fieldBeginDateLastJob" formControlName="beginDateLastJob"></app-datepicker>
                          <small *ngIf="submitted && diagnosticForm.controls?.beginDateLastJob?.errors?.dateFormat" class="form-text text-danger">
                            La date de début est invalide.
                          </small>
                          <small *ngIf="submitted && diagnosticForm.errors?.datesOrder" class="form-text text-danger">
                            La date de début doit être inférieure à la date de fin.
                          </small>
                        </div>
                        <div class="col-12 col-lg-6 mb-3 text-secondary">
                          <label>Date de fin dernier emploi</label>
                          <app-datepicker id="fieldEndDateLastJob" formControlName="endDateLastJob"> </app-datepicker>
                          <small *ngIf="submitted && diagnosticForm.controls?.endDateLastJob?.errors?.dateFormat" class="form-text text-danger">
                            La date de fin est invalide.
                          </small>
                          <small *ngIf="submitted && diagnosticForm.errors?.datesOrder" class="form-text text-danger">
                            La date de fin doit être supérieure à la date de début.
                          </small>
                        </div>
                      </div>

                      <!-- Parcours scolaire – Formations – Qualifications -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong> Parcours scolaire – Formations – Qualifications </strong>
                          </p>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-lg-6 mb-3">
                          <label class="text-secondary required">Niveau d'étude</label>
                          <select class="form-select" formControlName="degreeLabel">
                            <option *ngFor="let degree of degreesList; let i = index" [ngValue]="degree.label">{{ degree.label }}</option>
                          </select>
                        </div>
                        <div class="col-12 col-lg-6">
                          <div class="mb-3 text-secondary">
                            <label>Intitulé du diplôme le plus élevé</label>
                            <input type="text" class="form-control" formControlName="highestDegree" />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <app-dynamic-form
                          #formation
                          class="col-12"
                          title="Formations suivies"
                          [data]="diagnostic.formations"
                          [fields]="formationFields"
                          [showSeparator]="false"
                          [groupValidators]="groupValidators"
                          [asyncValidators]="asyncValidators"
                          [validatorsMessageTemplate]="validatorsTemplate"
                          noGroupText="Il n'y a aucune formation suivie de renseignée. Cliquez sur le bouton + pour en ajouter."
                        >
                          <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                            <div class="text-secondary col-5 mb-2" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0"
                                >Intitulé de la formation</label
                              >
                              <div class="input-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  formControlName="trainingTitle"
                                  [class.is-invalid]="submitted && group.controls?.trainingTitle?.invalid"
                                />
                              </div>
                              <small *ngIf="submitted && group.controls?.trainingTitle?.errors?.required" class="form-text text-danger"
                                >L'intitulé de la formation est requis.</small
                              >
                            </div>
                            <div class="text-secondary col-3 mb-2 ps-0" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Début formation</label>
                              <app-datepicker
                                formControlName="beginDateFormation"
                                [class.is-invalid]="submitted && group.controls?.beginDateFormation?.invalid"
                              ></app-datepicker>
                              <small *ngIf="submitted && group.controls?.beginDateFormation?.errors?.dateFormat" class="form-text text-danger">
                                La date de début est invalide.
                              </small>
                              <small *ngIf="submitted && group.errors?.datesOrder" class="form-text text-danger">
                                La date de début doit être inférieure à la date de fin.
                              </small>
                            </div>
                            <div class="text-secondary col-4 mb-2 ps-0" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Fin formation</label>
                              <div class="mb-3">
                                <div class="input-group">
                                  <app-datepicker
                                    class="me-3"
                                    id="endDateFormation"
                                    formControlName="endDateFormation"
                                    [class.is-invalid]="submitted && group.controls?.endDateFormation?.invalid"
                                  ></app-datepicker>
                                  <button
                                    type="button"
                                    ngbTooltip="Supprimer"
                                    placement="left"
                                    class="btn btn-outline-primary rounded"
                                    (click)="groupRemoved(groupIndex)"
                                  >
                                    <fa-icon icon="trash-alt"></fa-icon>
                                  </button>
                                </div>
                                <small *ngIf="submitted && group.controls?.endDateFormation?.errors?.dateFormat" class="form-text text-danger">
                                  La date de fin est invalide.
                                </small>
                                <small *ngIf="submitted && group.errors?.datesOrder" class="form-text text-danger">
                                  La date de fin doit être supérieure à la date de début.
                                </small>
                              </div>
                            </div>
                          </ng-template>
                        </app-dynamic-form>
                      </div>

                      <!-- Information permis de conduire -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong> Information permis de conduire </strong>
                          </p>
                        </div>
                      </div>
                      <div class="mb-3 row">
                        <label class="col-4 col-form-label">Permis de conduire :</label>
                        <div class="col-1">
                          <div class="form-check form-check-inline">
                            <input id="yes" type="radio" class="form-check-input" formControlName="drivingLicense" value="yes" />
                            <label for="madam" class="form-check-label">oui</label>
                          </div>
                        </div>
                        <div class="col-1">
                          <div class="form-check form-check-inline">
                            <input id="no" type="radio" class="form-check-input" formControlName="drivingLicense" value="no" />
                            <label for="mister" class="form-check-label">non</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label>Autres compétences</label>
                          <textarea formControlName="skills" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                      <!-- Freins périphériques à l’emploi identifiés -->
                      <div class="row mt-3">
                        <div class="col-12 col-lg-12">
                          <p id="barriersTitle">
                            <strong> Freins périphériques à l’emploi identifiés </strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <table class="table table-sm" *ngIf="barriers?.length > 0" aria-describedby="barriersTitle">
                            <thead class="bg-light">
                              <tr>
                                <th scope="col">Frein</th>
                                <th scope="col">Statut</th>
                                <th scope="col">Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let barrier of barriers">
                                <td>{{ barriersById.get(barrier.barrierId)?.label }}</td>
                                <td>{{ barrierStatus.get(barrier.barrierStatus) }}</td>
                                <td>{{ barrier.description }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && (diagnosticForm.invalid || children.form.invalid || formation.form.invalid)" class="form-text text-danger">
          Le diagnostic n'est pas complété correctement.
        </small>
      </div>
      <div class="row mt-4"></div>

      <!-- Prescription -->
      <div class="card border-1 card-border-radius-0" formGroupName="prescriptionForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Prescription</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <!-- Structure -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p><strong>Structure référente</strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Nom de la structure</label>
                            <input type="text" class="form-control" formControlName="structureLabel" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Adresse de la structure</label>
                            <input type="text" class="form-control" formControlName="structureAddress" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Complément d'adresse</label>
                            <input type="text" class="form-control" formControlName="structureAdditionalAddress" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Ville</label>
                            <input type="text" class="form-control" formControlName="structureCity" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Code postal</label>
                            <input type="text" class="form-control" formControlName="structurePostalCode" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Téléphone de la structure</label>
                            <input type="text" class="form-control" formControlName="structurePhone" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4">
                          <div class="mb-3 text-secondary">
                            <label>Référent</label>
                            <input type="text" class="form-control" formControlName="referentName" />
                          </div>
                        </div>
                        <div class="col-12 col-lg-4" *ngIf="!utils.isNotEmpty(diagnosticForm.controls?.referentPhone)">
                          <div class="mb-3 text-secondary">
                            <label>Téléphone du référent</label>
                            <input type="text" class="form-control" formControlName="referentPhone" />
                          </div>
                        </div>
                      </div>
                      <!-- Projet socioprofessionnel -->
                      <div class="row">
                        <div class="col-12">
                          <p><strong>Projet socioprofessionnel </strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label>(emploi, formation, levée des freins)</label>
                          <textarea formControlName="project" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                      <!-- Analyse du projet -->
                      <div class="row mt-3">
                        <div class="col-12">
                          <p><strong>Analyse du projet </strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label>Absence de projet</label>
                          <textarea formControlName="analysis1" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label>Expérience et compétences déjà acquises en lien avec le projet</label>
                          <textarea formControlName="analysis2" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label>Pertinence du projet au regard de la réalité socio-économique du bassin d’emploi</label>
                          <textarea formControlName="analysis3" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label>Atouts et points forts</label>
                          <textarea formControlName="analysis4" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label>Compétences à développer en lien avec le projet</label>
                          <textarea formControlName="analysis5" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <label>Observations complémentaires</label>
                          <textarea formControlName="analysis6" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Boutons actions -->
    <div class="row px-3">
      <div class="col-6 col-md-9 col-lg-6 mb-2" *ngIf="!isConsultMode"></div>
      <div class="col-3 col-md-9 col-lg-3 mb-2" *ngIf="isConsultMode"></div>
      <div ngbDropdown class="d-grid col-3 col-md-9 col-lg-3 mb-2" *ngIf="isConsultMode">
        <button class="btn btn-primary" id="dropdownActions" type="button" ngbDropdownToggle>
          <fa-icon icon="toolbox"></fa-icon>
          <span class="mx-3">Actions</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownActions">
          <button
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY']"
            class="btn btn-primary d-flex"
            type="button"
            ngbDropdownItem
            (click)="downloadDocument()"
          >
            <fa-icon icon="print"></fa-icon>
            <span class="ms-3 d-none d-md-block">Générer</span>
          </button>
          <div *ngIf="diagnostic.diagnosticStatus === 'InProgress' || diagnostic.diagnosticStatus === 'Signed'">
            <button
              *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY']"
              class="btn btn-primary d-flex"
              type="button"
              ngbDropdownItem
              (click)="syncAssessment()"
            >
              <fa-icon icon="sync"></fa-icon>
              <span class="ms-3 d-none d-md-block">Synchroniser</span>
            </button>
          </div>

          <button
            type="button"
            class="btn btn-primary d-flex"
            (click)="delete()"
            ngbDropdownItem
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY']"
          >
            <fa-icon icon="trash"></fa-icon>
            <span class="ms-3 d-none d-md-block">Supprimer</span>
          </button>
        </div>
      </div>

      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-3 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY']" class="btn btn-primary d-flex justify-content-center" type="submit">
          <fa-icon icon="save"></fa-icon>
          <span class="ms-3 d-none d-md-block">Sauvegarder</span>
        </button>
      </div>
    </div>
  </form>
</div>
